import script from "./QuestionnaireList.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionnaireList.vue?vue&type=script&setup=true&lang=js"

import "./QuestionnaireList.vue?vue&type=style&index=0&id=63dce9bc&scoped=true&lang=css"
script.__scopeId = "data-v-63dce9bc"

export default script